<template>
	<ui-modal :show="show" @update:show="$emit('update:show', $event)">
		<ui-panel>
			<ui-panel-title>
				<div class="panel-heading">Guest Already Exists</div>
			</ui-panel-title>
			<ui-panel-body>
				<p class="mb-3">
					A guest with the email <strong>{{ email }}</strong> already exists. 
					Please select an existing guest or use a different email address.
				</p>

				<div v-if="guests.length > 0">
					<div class="caption mb-2">Existing Guests:</div>
					<ui-list>
						<ui-list-section>
							<ui-list-item-row 
								v-for="guest in guests" 
								:key="guest.id"
								:class="{ 'is-selected': selectedGuestId === guest.id }"
								@click="selectedGuestId = guest.id">
								<ui-list-item-content>
									<ui-list-item-title>{{ guest.first_name }} {{ guest.last_name }}</ui-list-item-title>
									<ui-list-item-subtitle>{{ guest.primary_email }}</ui-list-item-subtitle>
								</ui-list-item-content>
								<ui-list-item-action>
									<ui-icon 
										v-if="selectedGuestId === guest.id" 
										icon="fas fa-check-circle" 
										color="primary" />
								</ui-list-item-action>
							</ui-list-item-row>
						</ui-list-section>
					</ui-list>
				</div>
			</ui-panel-body>
			<ui-panel-footer>
				<ui-button 
					color="primary" 
					:disabled="!selectedGuestId" 
					:loading="loading"
					@click="useSelectedGuest">
					Use Selected Guest
				</ui-button>
				<ui-button 
					color="text" 
					:disabled="loading"
					@click="cancel">
					Cancel
				</ui-button>
			</ui-panel-footer>
		</ui-panel>
	</ui-modal>
</template>

<script>
export default {
	props: {
		show: { type: Boolean, default: false },
		email: { type: String, default: '' },
		guests: { type: Array, default: () => [] },
	},

	data()
	{
		return {
			selectedGuestId: null,
			loading: false,
		}
	},

	watch: {
		show(newVal)
		{
			if (newVal)
			{
				// Reset selection when modal opens
				this.selectedGuestId = this.guests.length > 0 ? this.guests[0].id : null;
			}
		},

		guests(newVal)
		{
			// Auto-select first guest if available
			if (newVal.length > 0)
				this.selectedGuestId = newVal[0].id;
		}
	},

	methods: {
		useSelectedGuest()
		{
			if (!this.selectedGuestId)
				return;

			const selectedGuest = this.guests.find(g => g.id === this.selectedGuestId);
			this.$emit('selected', selectedGuest);
		},

		cancel()
		{
			this.$emit('cancel');
		}
	}
}
</script>

<style scoped>
.is-selected {
	background-color: rgba(0, 0, 0, 0.05);
}
</style>

